<template>
  <validation-observer tag="div" ref="form" class="mb-3">
    <div class="row">
      <div class="col-md-6">
        <validation-provider
            v-if="!this.model.id"
            v-slot="{ validated, errors }"
            :name="lodash.startCase($t('purchase_payments.ticket_id'))"
            rules="required"
            vid="ticket_id"
        >
          <b-form-group
              :invalid-feedback="errors[0]"
              :label="`${lodash.startCase($t('purchase_payments.ticket_id'))}`"
              :state="errors[0] ? false : validated ? true : null"
              class="row"
              label-cols-md="12"
          >
            <multiselect-ajax
                :key="`${_uid}-tickets`"
                v-model.number="model.ticketable.ticket_id"
                :custom-label="ticketCustomLabel"
                :disabled="$route.params.key"
                :modify-response="ticketModifyResponse"
                :params="ticketParams"
                name="ticket_id"
                url="/tickets"
                @update:selected="onTicketUpdated"
            >
            </multiselect-ajax>
          </b-form-group>
        </validation-provider>
        <b-form-group v-else class="row" label-cols-md="12" :label="`${lodash.startCase($t('purchase_payments.ticket_id'))}`">
          <b-form-input :value="ticketCustomLabel(model.ticketable.ticket)" disabled name="ticket_id" type="text"></b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <validation-provider v-if="!this.model.id" vid="trip_id" name="ID nota armada" rules="required" v-slot="{ validated, errors }">
          <b-form-group

              :invalid-feedback="errors[0]"
              label="ID Nota Armada"
              label-class="required-indicator"
              :state="errors[0] ? false : validated ? true : null"
              class="row"
              label-cols-md="12"
          >
            <multiselect-ajax
                :key="`${_uid}-trip-${model.ticketable.ticket_id}`"
                v-model.number="model.trip_id"
                :custom-label="tripCustomLabel"
                :disabled="$route.params.key"
                :modify-response="tripModifyResponse"
                :params="tripParams"
                :url="`/trips`"
                name="ID nota armada"
                @update:selected="onTripSelected"
            >
            </multiselect-ajax>
          </b-form-group>
        </validation-provider>
        <b-form-group v-else class="row" label-cols-md="12" label="ID Nota Armada">
          <b-form-input :value="tripCustomLabel(model.trip)" disabled name="trip_id" type="text"></b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group class="row" label-cols-md="12" :label="`Pabrik`">
          <b-form-input :value="processingName" disabled name="processing" type="text"></b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group class="row" label-cols-md="12" :label="`Supir`">
          <b-form-input :value="driverName" disabled name="driver" type="text"></b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group class="row" label-cols-md="12" :label="`Kendaraan`">
          <b-form-input :value="vehicleName" disabled name="vehicle" type="text"></b-form-input>
        </b-form-group>
      </div>
      <validation-provider
          v-slot="{ validated, errors }"
          :name="lodash.startCase($t('unloads.fibers'))"
          :vid="`unloads.${key}.fibers`"
          class="col-md-6"
          rules="gt:0|integer|required"
      >
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="`${lodash.startCase($t('unloads.fibers'))}`"
            label-class="required-indicator"
            :state="errors[0] ? false : validated ? true : null"
            class="row"
            label-cols-md="12"
        >
          <b-input-group>
            <numeral-input
                id="fibers"
                v-model="model.box"
                :name="`unloads[fibers]`"
                :placeholder="`${lodash.startCase($t('unloads.fibers'))}`"
                :state="errors[0] ? false : validated ? true : null"
                style="text-align: right"
            />
          </b-input-group>
        </b-form-group>
      </validation-provider>
      <div class="col-md-3">
        <validation-provider
            v-slot="{ validated, errors }"
            :rules="orderedAtRules"
            name="Tanggal Nota Bongkar"
            vid="ordered_at"
        >
          <b-form-group
              :invalid-feedback="errors[0]"
              :state="errors[0] ? false : validated ? true : null"
              class="row"
              label="Tanggal Nota Bongkar"
              label-class="required-indicator"
              label-cols-md="12"
          >
            <date-picker
                v-model="model.ordered_at"
                :state="errors[0] ? false : validated ? true : null"
                format="DD MMMM YYYY"
                name="ordered_at"
                type="date"
                @input="model.ordered_at = $event"
            ></date-picker>
          </b-form-group>
        </validation-provider>
      </div>
      <div class="col-md-3">
        <validation-provider
            v-slot="{ validated, errors }"
            :name="`${lodash.upperFirst($t('unloads.duration'))}`"
            :rules="`required|min_value:0`"
            vid="duration"
        >
          <b-form-group
              :invalid-feedback="errors[0]"
              :label="`${lodash.upperFirst($t('unloads.duration'))}`"
              label-class="required-indicator"
              :state="errors[0] ? false : validated ? true : null"
              class="row"
              label-cols-md="12"
          >
            <numeral-input
                id="duration"
                v-model="model.duration"
                :name="`unloads.duration`"
                :placeholder="`${lodash.startCase($t('unloads.duration'))}`"
                :state="errors[0] ? false : validated ? true : null"
                style="text-align: right"
            />
          </b-form-group>
        </validation-provider>
      </div>
      <div class="col-md-6">
        <b-form-group class="row" label-cols-md="12" :label="`${lodash.upperFirst($t('unloads.due_at'))}`">
          <b-input-group>
            <b-form-input
                id="due_date"
                v-model="dueDate"
                :placeholder="lodash.upperFirst($t('due_date'))"
                name="due-date"
                readonly
                type="text"
            />
          </b-input-group>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <validation-provider
            v-slot="{ validated, errors }"
            :name="$t('unloads.send_to_odoo')"
            class="col-md-6"
            vid="send_to_rfq"
        >
          <b-form-group
              :invalid-feedback="errors[0]"
              :label="$t('unloads.forms.send_to_odoo_question')"
              :state="errors[0] ? false : validated ? true : null"
              class="row mb-3"
              label-cols-md="12"
          >
            <b-form-checkbox
                v-model="model.send_to_odoo"
                :unchecked-value="false"
                :value="true"
                name="send_to_odoo"
                stacked
            />
          </b-form-group>
        </validation-provider>
      </div>

      <validation-provider
          v-slot="{ validated, errors }"
          :rules="fileValidationRules"
          name="attachment"
          vid="files"
          ref="fileProvider"
      >
        <b-form-group
            :invalid-feedback="errors[0]"
            :state="errors[0] ? false : validated ? true : null"
            class="row custom-attachment"
            label="Attachment (PNG, JPG, PDF)"
            label-class="attachment required-indicator"
            label-cols-md="12"
        >
          <div class="row">
            <div class="col-md-6">
              <file-drag-and-drop
                  v-model="model.files"
                  :drop-placeholder="lodash.upperFirst($t('drop file here'))"
                  :placeholder="lodash.upperFirst($t('choose a file or drop it here'))"
                  :state="errors[0] ? false : validated ? true : null"
                  accept="image/jpeg,image/png,application/pdf"
                  name="files"
              ></file-drag-and-drop>
            </div>
          </div>
        </b-form-group>
        <div class="col-md-12">
          <div class="d-flex flex-wrap gap-2">
            <template v-for="(file, index) in model.files">
              <file-item
                  v-if="file._action !== 'delete'"
                  :key="index"
                  :deletable="true"
                  :file="file"
                  @delete="removeFile('files', index)"
              ></file-item>
            </template>
          </div>
        </div>
      </validation-provider>
    </div>
    <hr/>
    <sale-item
        key="sale-item"
        v-model="model.sale_items"
        @merge-item="mergeSaleItem"
        @ungroup-item="ungroupSaleItem"
        @partial-item="partialSaleItem"
        @remove-partial-item="removePartialItem"
    />
    <div class="row">
      <div class="col-md-3 text-center" :key="`purchase-order-total-initial-quantity-${totalQuantity}`">
        {{ lodash.startCase($t("unloads.purchase_order_total_biomassa")) }}:
        {{ $numeral(tripItemTotalQuantity).format("0,0.[00]") }} {{ lodash.startCase($t("units.kg")) }}
      </div>
      <div class="col-md-3 text-center" :key="`delivery-order-total-quantity-${estimatedTotalQuantity}`">
        {{ lodash.startCase($t("unloads.estimated_quantity_total")) }}:
        {{ $numeral(estimatedTotalQuantity).format("0,0.[00]") }} {{ lodash.startCase($t("units.kg")) }}
      </div>
      <div class="col-md-3 text-center" :key="`purchase-order-total-quantity-${saleItemTotalQuantity}`">
        {{ lodash.startCase($t("unloads.actual_quantity_total")) }}:
        {{ $numeral(saleItemTotalQuantity).format("0,0.[00]") }} {{ lodash.startCase($t("units.kg")) }}
      </div>
      <div class="col-md-3 text-center" :key="`sale-order-total-${actualTotalPrice}`">
        {{ lodash.startCase($t("unloads.actual_total_price")) }}: {{ $numeral(actualTotalPrice).format("$ 0,0.[00]") }}
      </div>
    </div>
    <hr/>
    <b-form-group class="row" label-cols-md="12" :label="`Biaya Ditanggung JALA`" label-class="section-header">
      <template v-for="(additional_item, key) in undeletedItems('sale_paid_by_jala')">
        <div :key="`sale_paid_by_jala.key.${key}`" v-if="additional_item._action !== 'delete'">
          <div :key="`sale_paid_by_jala.key.${key}`" :class="`row g-2 ${key === 0 ? '' : 'mt-2'}`">
            <!-- make sure additional_item is unique -->
            <validation-provider
                v-slot="{ validated, errors }"
                :name="lodash.upperFirst(`${$t('additional_fees.name')}`)"
                :vid="`sale_paid_by_jala.${key}.name`"
                class="col-md-6"
                rules="required"
            >
              <b-form-group
                  :disabled="additional_item.disabled"
                  :invalid-feedback="errors[0]"
                  :label="lodash.upperFirst(`${$t('additional_fees.name')}`)"
                  :state="errors[0] ? false : validated ? true : null"
              >
                <b-form-input
                    :id="`${_uid}-name`"
                    v-model="additional_item['name']"
                    :name="`sale_paid_by_jala[${key}][name]`"
                    :placeholder="lodash.upperFirst('Ex: PPN')"
                    :state="errors[0] ? false : validated ? true : null"
                    type="text"
                ></b-form-input>
              </b-form-group>
            </validation-provider>
            <validation-provider
                v-slot="{ validated, errors }"
                :name="lodash.upperFirst(`${$t('additional_fees.total')} ${key + 1}`)"
                :vid="`additional_fees.${key}.total`"
                class="col-md-5"
            >
              <b-form-group
                  :invalid-feedback="errors[0]"
                  :label="`${lodash.upperFirst($t('additional_fees.total'))}`"
                  :state="errors[0] ? false : validated ? true : null"
              >
                <b-input-group prepend="Rp">
                  <numeral-input
                      :id="`${_uid}-value`"
                      v-model="additional_item['total']"
                      :name="`additional_fees[${key}][total]`"
                      :placeholder="lodash.upperFirst('Ex: 1000')"
                      :state="errors[0] ? false : validated ? true : null"
                      format="0,0.[00]"
                      lazy-formatter
                      @blur="onBlurSaleAdditionalItemTotal"
                  />
                </b-input-group>
              </b-form-group>
            </validation-provider>
            <validation-provider
                v-if="(additional_item.options || {}).show_markup_margin_checkbox"
                v-slot="{ validated, errors }"
                :name="lodash.upperFirst(`${$t('unloads.additional_fees.is_markup_margin_item')} ${$key + 1}`)"
                :vid="`additional_fees.${key}.is_markup_margin_item`"
                class="col-md-1"
            >
              <b-form-group
                  :invalid-feedback="errors[0]"
                  :label="`${lodash.upperFirst($t('unloads.additional_fees.is_markup_margin_item'))}?`"
                  :state="errors[0] ? false : validated ? true : null"
              >
                <b-form-checkbox
                    v-model="additional_item['is_markup_margin_item']"
                    name="check-button"
                    switch
                    size="lg"
                >
                  {{
                    additional_item['is_markup_margin_item'] ? lodash.upperFirst($t("yes")) : lodash.upperFirst($t("no"))
                  }}
                </b-form-checkbox>
              </b-form-group>
            </validation-provider>
          </div>
          <div :key="`sale_paid_by_jala.key.${key}.delete`" class="row g-2 mt-2">
            <div class="col-sm delete-item">
              <div class="float-end">
                <b-button
                    v-if="!additional_item.disabled"
                    class="text-danger"
                    size="sm"
                    style="margin-right: 10px"
                    tag="span"
                    variant="link"
                    @click="removeItem('sale_paid_by_jala', key)"
                >{{ $t("Delete") }}
                </b-button
                >
                <b-button
                    v-if="key === undeletedItems('sale_paid_by_jala').length - 1"
                    size="sm"
                    tag="span"
                    variant="link"
                    @click="addItem('sale_paid_by_jala', { paid_by: 'jala', options: { show_markup_margin_checkbox: true }})"
                >
                  {{ $t("Add new {something}", {something: ""}) }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </template>
      <b-form-group
          class="col-md-6"
          :label="`${lodash.upperFirst($t('unloads.additional_fees.margin_in_kg'))}`"
      >
        <b-input-group prepend="Rp">
          <numeral-input
              :value="markupMarginKg"
              format="0,0.[00]"
              disabled
          />
        </b-input-group>
      </b-form-group>
      <div class="clearfix" v-if="!undeletedItems('sale_paid_by_jala').length">
        <div class="float-end">
          <b-button size="sm" tag="span" variant="link" @click="addItem('sale_paid_by_jala', { paid_by: 'jala' })">
            {{ $t("Add new {something}", {something: ""}) }}
          </b-button>
        </div>
      </div>
    </b-form-group>
    <hr v-if="!isJalaHarvest"/>
    <b-form-group
        v-if="!isJalaHarvest"
        :label="lodash.startCase('biaya diteruskan ke mitra')"
        class="row"
        label-class="section-header"
        label-cols-md="12"
    >
      <template v-for="(additional_item, key) in undeletedItems('sale_paid_by_partner')">
        <div :key="`sale_paid_by_partner.key.${key}`" v-if="additional_item._action !== 'delete'">
          <div :key="`sale_paid_by_partner.key.${key}`" :class="`row g-2 ${key === 0 ? '' : 'mt-2'}`">
            <validation-provider
                v-slot="{ validated, errors }"
                :name="lodash.upperFirst(`${$t('additional_fees.name')}`)"
                :vid="`sale_paid_by_partner.${key}.name`"
                class="col-md-6"
                rules="required"
            >
              <b-form-group
                  :disabled="additional_item.disabled"
                  :invalid-feedback="errors[0]"
                  :label="lodash.upperFirst(`${$t('additional_fees.name')}`)"
                  :state="errors[0] ? false : validated ? true : null"
              >
                <b-form-input
                    :id="`${_uid}-name`"
                    v-model="additional_item['name']"
                    :name="`sale_paid_by_partner[${key}][name]`"
                    :placeholder="lodash.upperFirst('Ex: PPN')"
                    :state="errors[0] ? false : validated ? true : null"
                    type="text"
                ></b-form-input>
              </b-form-group>
            </validation-provider>
            <validation-provider
                v-slot="{ validated, errors }"
                :name="lodash.upperFirst(`${$t('additional_fees.total')} ${key + 1}`)"
                :vid="`additional_fees.${key}.total`"
                class="col-md-6"
            >
              <b-form-group
                  :invalid-feedback="errors[0]"
                  :label="`${lodash.upperFirst($t('additional_fees.total'))}`"
                  :state="errors[0] ? false : validated ? true : null"
              >
                <b-input-group prepend="Rp">
                  <numeral-input
                      :id="`${_uid}-value`"
                      v-model="additional_item['total']"
                      :name="`additional_fees[${key}][total]`"
                      :placeholder="lodash.upperFirst('Ex: 1000')"
                      :state="errors[0] ? false : validated ? true : null"
                      format="0,0.[00]"
                      lazy-formatter
                      @blur="onBlurSaleAdditionalItemTotal"
                  />
                </b-input-group>
              </b-form-group>
            </validation-provider>
          </div>
          <div :key="`sale_paid_by_partner.key.${key}.delete`" class="row g-2 mt-2">
            <div class="col-sm delete-item">
              <div class="float-end">
                <b-button
                    v-if="!additional_item.disabled"
                    class="text-danger"
                    size="sm"
                    style="margin-right: 10px"
                    tag="span"
                    variant="link"
                    @click="removeItem('sale_paid_by_partner', key)"
                >{{ $t("Delete") }}
                </b-button
                >
                <b-button
                    v-if="key === undeletedItems('sale_paid_by_partner').length - 1"
                    size="sm"
                    tag="span"
                    variant="link"
                    @click="addItem('sale_paid_by_partner', { paid_by: 'partner' })"
                >
                  {{ $t("Add new {something}", {something: ""}) }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="clearfix" v-if="!undeletedItems('sale_paid_by_partner').length">
        <div class="float-end">
          <b-button
              size="sm"
              tag="span"
              variant="link"
              @click="addItem('sale_paid_by_partner', { paid_by: 'partner' })"
          >
            {{ $t("Add new {something}", {something: ""}) }}
          </b-button>
        </div>
      </div>
    </b-form-group>
    <hr/>
    <validation-provider
        v-slot="{ validated, errors }"
        :name="lodash.upperFirst($t('unloads.total'))"
        rules="required|gt:0"
        vid="total"
    >
      <b-form-group
          :invalid-feedback="errors[0]"
          :label="lodash.startCase($t('unloads.total'))"
          :state="errors[0] ? false : validated ? true : null"
          class="row"
          label-cols-md="12"
      >
        <numeral-input
            id="total"
            v-model.number="model.total"
            :disabled="true"
            :placeholder="lodash.upperFirst($t('unloads.total'))"
            :state="errors[0] ? false : validated ? true : null"
            format="$ 0,0.[00]"
            name="total"
            style="text-align: right"
        />
      </b-form-group>
    </validation-provider>
    <hr/>
    <validation-provider
        v-slot="{ validated, errors }"
        :name="lodash.upperFirst($t('models.description'))"
        rules="max:255"
        vid="description"
    >
      <b-form-group
          :invalid-feedback="errors[0]"
          :state="errors[0] ? false : validated ? true : null"
          class="row"
          label="Catatan"
          label-cols-md="12"
      >
        <editor
            v-if="$parent.$parent.$options.name !== 'BModal'"
            ref="editor"
            v-model="model.description"
            :init="editorInit"
            class="form-control"
            inline
            plugins="lists link image paste help wordcount"
            toolbar="undo redo | styleselect | fontselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent"
        />
        <b-form-textarea v-else v-model="model.description"/>
      </b-form-group>
    </validation-provider>
  </validation-observer>
</template>
<script>
import FormModel from "./model";
import FileDragAndDrop from "@/components/inputs/file-input";
import FileItem from "@/components/inputs/file-item";
import SaleItem from "@/components/forms/unloads/sale-item.vue";
import {round} from "lodash";

export default {
  extends: FormModel,
  components: {
    FileDragAndDrop,
    FileItem,
    SaleItem,
  },
  data() {
    return {
      backupFile: {
        files: !this.lodash.isEmpty(this.value.files) ? this.value.files : {name: "files"}
      },
      file_accepts: ["image/jpeg", "image/jpg", "image/png", "application/pdf"],
      dueAt: null,
      ...this.value,
      firstFile: null,
      selectedCustomerType: null,
      quality_options: [
        {value: "fresh", text: "Fresh"},
        {value: "km", text: "Kulit Muda (KM)"},
        {value: "bs", text: "Below Standard (BS)"},
        {value: "us", text: "Under Size (US)"},
        {value: "merah", text: "Merah"}
      ],
      fund_options: [
        {value: "fresh", text: "Fresh"},
        {value: "kmtb", text: "KMTB"}
      ],
      preview: "",
      model: {
        send_to_odoo: true,
        total: 0,
        ...this.value,
        unit_duration: "days",
        files: [...((this.value.files || []).length ? this.value.files : [])],
        purchase_items: [...((this.value.purchase_items || []).length ? this.value.purchase_items : [{}])],
        sale_items: [
          ...((this.value.sale_items || []).length
              ? this.value.sale_items
              : [])
        ],
        actual_sale_items: [...((this.value.actual_sale_items || []).length ? this.value.actual_sale_items : [])],
        sale_additional_items: [
          ...((this.value.sale_additional_items || []).length ? this.value.sale_additional_items : [])
        ],
        additional_fees: [...((this.value.sale_additional_fees || []).length ? this.value.sale_additional_fees : [])],
        discounts: [...((this.value.sale_discounts || []).length ? this.value.sale_discounts : [])],
        ticket: !this.lodash.isEmpty(this.value.ticket) ? this.value.ticket : {},
        ticketable: !this.lodash.isEmpty(this.value.ticketable) ? this.value.ticketable : {ticket_id: null},
        paymentable: !this.lodash.isEmpty(this.value.paymentable)
            ? this.value.paymentable
            : {id: null, ticketable: {ticket: {}}},
        trip_items: [],
        biomassa_incremental_factor: 1.12,
        size_incremental_factor: 0.9,
        sale_paid_by_jala: [
          ...((this.value.sale_paid_by_jala || []).length
              ? this.value.sale_paid_by_jala
              : [
                {name: "Diskon", total: 0, disabled: true, paid_by: "jala", options: { show_markup_margin_checkbox: true }},
                {name: "Biaya Percepatan", total: 0, disabled: true, paid_by: "jala"},
              ])
        ],
        sale_paid_by_partner: [
          ...((this.value.sale_paid_by_partner || []).length
              ? this.value.sale_paid_by_partner
              : [
                {name: "Diskon", total: 0, disabled: true, paid_by: "partner"},
                {name: "PPH 22", total: 0, disabled: true, paid_by: "partner"},
                {name: "Moulting", total: 0, disabled: true, paid_by: "partner"}
              ])
        ]
      }
    };
  },
  mounted() {
    const params = this.$route.params;
    this.$set(this, "model", {
      ...this.model,
      ...params
    });
    this.setSaleOrderTotal();
    // this.checkLocalStorage()
  },
  watch: {
    'model.trip': function (val) {
      this.$nextTick(() => {
        this.model.type = val?.type
        if (!this.model.id) {
          this.setDefaultAdditionalItems(this.model.type)
        }
      })
    },
    "model.ticketable.ticket_id": function () {
      this.$set(this.model, "trip", null);
      this.$set(this.model, "trip_items", []);
    },
    model: {
      deep: true,
      handler: function () {
        let dueAt = null;
        if (this.model.ordered_at) {
          dueAt = this.$moment(this.model.ordered_at)
              .add(this.model.duration || 0, "days")
              .format("YYYY-MM-DD");
        }
        this.dueAt = dueAt;
      }
    },
    saleItemTotal() {
      this.setSaleOrderTotal();
    },
    saleAdditionalItemTotal() {
      this.setSaleOrderTotal();
    }
  },
  computed: {
    fileValidationRules() {
      return this.model.id ? {
        required: true,
        files_required: true,
        files_mimes: ['image/jpeg', 'image/png', 'application/pdf'],
      } : {
        required: true,
        files_required: true,
        files_mimes: ['image/jpeg', 'image/png', 'application/pdf'],
      }
    },
    ticketParams() {
      return {
        with: 'creator,purchase_orders,trips.trip_items.purchase_item,vehicle,trips.sale_orders',
        customer_type: 'lcs',
        where_has: 'trips',
        sort: 'id,desc'
      };
    },
    tripParams() {
      return {
        ticket_id: this.model.ticketable.ticket_id,
        with:
          'vehicle,driver,trip_items.purchase_item.purchase_order.product,customer,sale_orders,delivery_order',
        sort: 'id,desc'
      };
    },
    markupMarginKg() {
      return this.saleItemTotalQuantity > 0 ?
          this.undeletedItems('sale_paid_by_jala')
              .filter(v => v.is_markup_margin_item).reduce((acc, {total}) => acc + total, 0) / this.saleItemTotalQuantity
          : 0
    },
    dueDate() {
      if (!this.model.ordered_at) return "-";
      let dueDate = this.$moment(this.model.ordered_at, "YYYY-MM-DD").add(
          this.model.duration > 0 ? this.model.duration : 0,
          this.model.unit_duration
      );
      return dueDate.format("D MMMM YYYY");
    },
    isJalaHarvest() {
      let tripItem = this.model.trip_items[0]
      return tripItem?.purchase_item?.purchase_order?.type === 'harvest'
    },
    customerName() {
      return "-";
      // return (
      //   this.model?.sale_items[0]?.purchase_item?.purchase_order?.customer
      //     ?.name || "-"
      // );
    },
    vehicleName() {
      let vehicle = this.model?.trip?.vehicle;
      let vehicleName = vehicle?.name;

      if (vehicle?.type === "heavy") vehicleName = this.$t("vehicles.truck");
      else if (vehicle?.type === "medium") vehicleName = this.$t("vehicles.crank_truck");
      else if (vehicle?.type === "light") vehicleName = this.$t("vehicles.pickup");

      return vehicle ? `${this.lodash.upperFirst(vehicleName)} - ${vehicle?.license_plate}` : "";
    },
    driverName() {
      return this.model?.trip?.driver?.name
          ? `${this.model?.trip?.driver?.name} - ${this.model?.trip?.driver?.phone_number}`
          : "";
    },
    processingName() {
      if (this.model.id) {
        return `${this.model.customer.name} (${this.model.customer.code})`
      }
      return this.model?.trip?.customer ? `${this.model.trip.customer.name} (${this.model.trip.customer.code})` : "";
    },
    actualTotalPrice() {
      return this.model.sale_items
          .filter(({_action}) => _action !== "delete")
          .reduce((acc, {quantity, unit_price}) => acc + round(quantity * unit_price, 2), 0);
    },
    saleItemTotalQuantity() {
      return this.model.sale_items.reduce((acc, {quantity}) => acc + quantity ?? 0, 0);
    },
    estimatedTotalQuantity() {
      return this.uniqueTripItems.reduce((acc, {quantity}) => acc + (quantity ?? 0) * 1.12, 0)
    },
    uniqueTripItems() {
      let flattenTripItems = this.model.sale_items.flatMap(({trip_items}) => trip_items)

      return flattenTripItems.length ?  this.lodash.uniqBy(flattenTripItems, 'id') : []
    },
    tripItemTotalQuantity() {
      return this.uniqueTripItems.reduce((acc, {quantity}) => acc + (quantity ?? 0), 0)
    },
    totalQuantity() {
      const total = this.model.trip_items.reduce((acc, item) => {
        return acc + item.quantity;
      }, 0);
      return total;
    },
    saleOrderTotalPrice() {
      const additionalFees = [
        ...this.undeletedItems("sale_paid_by_jala"),
        ...this.undeletedItems("sale_paid_by_partner")
      ].reduce((acc, item) => {
        acc += item.total || 0;
        return acc;
      }, 0);

      return this.actualTotalPrice - additionalFees;
    },
    purchaseOrderTotalTonase() {
      return [...this.undeletedItems("sale_items"), ...this.undeletedItems("actual_sale_items")].reduce(
          (total, v) => total + (v.quantity || 0),
          0
      );
    },
    latestPurchaseOrder() {
      const tripItems = this.model.trip_items;
      const latest =
          tripItems.sort((a, b) => {
            return (
                new Date(b.purchase_item.purchase_order.ordered_at) - new Date(a.purchase_item.purchase_order.ordered_at)
            );
          })?.[0] || null;
      if (latest) {
        return latest.purchase_item.purchase_order;
      }
      return {};
    },
    orderedAtRules() {
      return {
        required: true,
        after_or_equal: this.$moment(this.model.trip?.tripped_at).format("YYYY-MM-DD"),
        before_or_equal: this.$moment().format("YYYY-MM-DD"),
      }
    },
    saleItemTotal() {
      let editableSaleItems = (this.model.sale_items || []).filter(({_action}) => _action !== "delete");
      return editableSaleItems.reduce((total, saleItem) => {
        const quantity = saleItem.quantity || 0;
        const unitPrice = saleItem.unit_price || 0;
        return total + round(quantity * unitPrice, 2);
      }, 0);
    },
    saleAdditionalItemTotal() {
      let paidByJala = -this.model.sale_paid_by_jala
          .filter(item => item._action !== "delete")
          .reduce((total, item) => total + item.total, 0);
      let paidByPartner = -this.model.sale_paid_by_partner
          .filter(item => item._action !== "delete")
          .reduce((total, item) => total + item.total, 0);

      return paidByJala + paidByPartner;
    }
  },
  methods: {
    ensureSaleItemsOrderKeys() {
      (this.model.sale_items || []).forEach((item, index) => {
        this.$set(item, "order_key", index)
      })
    },
    mergeSaleItem(selectedIndexes = []) {
      this.ensureSaleItemsOrderKeys()
      const saleItems = this.model.sale_items || []
      const validIndexes = [...new Set(selectedIndexes
          .filter(index => Number.isInteger(index) && index >= 0 && index < saleItems.length)
          .sort((a, b) => a - b)
      )]
      if (!validIndexes.length) {
        return
      }

      const firstIndexMergeItem = validIndexes[0]
      const selectedItems = validIndexes
          .map(index => saleItems[index])
          .filter(Boolean)
      if (!selectedItems.length) {
        return
      }

      const mergeSources = selectedItems.map((item, sourceIndex) => ({
        sequence: typeof item.order_key === "number" ? item.order_key : validIndexes[sourceIndex],
        trip_item_ids: item.trip_item_ids || [],
        trip_items: item.trip_items || [],
        product_code: item.product_code
      }))

      const mergedItem = {
        ...selectedItems[0],
        quality: 'fresh',
        quantity: null,
        size: null,
        unit_price: null,
        trip_item_ids: [...new Set(mergeSources.flatMap(({trip_item_ids}) => trip_item_ids))],
        trip_items: this.lodash.uniqBy(mergeSources.flatMap(({trip_items}) => trip_items), "id"),
        trip_item_relation_type: "merge",
        order_key: Math.min(...mergeSources.map(({sequence}) => sequence)),
        merge_meta: mergeSources,
        is_first_partial_item: false,
        selected_checkbox: false,
        disabled_checkbox: true,
        show_partial_button: false,
      }
      delete mergedItem.id

      this.lodash.reverse([...validIndexes]).forEach(index => {
        if(saleItems[index].id) {
          this.$set(saleItems[index], "_action", 'delete')
        } else {
          saleItems.splice(index, 1)
        }
      })

      saleItems.splice(firstIndexMergeItem, 0, mergedItem)
      this.ensureSaleItemsOrderKeys()
    },
    ungroupSaleItem(selectedIndex = null) {
      const saleItems = this.model.sale_items || []
      let isValidIndex = Number.isInteger(selectedIndex) && selectedIndex >= 0 && selectedIndex < saleItems.length
      if (!isValidIndex) {
        return
      }

      let mergedItem = saleItems[selectedIndex]
      if (!mergedItem.trip_item_relation_type || mergedItem.trip_item_relation_type !== "merge") {
        return
      }

      this.ensureSaleItemsOrderKeys()

      const getMinimumTripItemId = (tripItemIds) => {
        if (!Array.isArray(tripItemIds) || !tripItemIds.length) {
          return Number.POSITIVE_INFINITY;
        }
        const numericIds = tripItemIds
            .map(id => (typeof id === "string" ? Number(id) : id))
            .filter(id => typeof id === "number" && !Number.isNaN(id));
        if (!numericIds.length) {
          return Number.POSITIVE_INFINITY;
        }
        return Math.min(...numericIds);
      }

      const buildSources = (mergedItem) => {
        if (!mergedItem) {
          return []
        }
        if (Array.isArray(mergedItem.merge_meta) && mergedItem.merge_meta.length) {
          return mergedItem.merge_meta
        }
        return (mergedItem.trip_items || []).map((tripItem, idx) => ({
          sequence: typeof mergedItem.order_key === "number" ? mergedItem.order_key + idx : idx,
          trip_item_ids: Array.isArray(tripItem.trip_item_ids)
              ? tripItem.trip_item_ids
              : tripItem.id
                  ? [tripItem.id]
                  : [],
          trip_items: [tripItem],
          product_code: tripItem.product_code || mergedItem.product_code
        }))
      }

      let sources = buildSources(mergedItem)
      if (!sources.length) {
        if (mergedItem.id) {
          this.$set(saleItems, selectedIndex, {
            ...mergedItem,
            _action: "delete",
          })
        } else {
          saleItems.splice(selectedIndex, 1)
        }
        return
      }

      const baseSaleItem = {
        ...mergedItem,
        _action: undefined,
        trip_item_relation_type: 'single',
        quality: 'fresh',
        size: null,
        quantity: null,
        unit_price: null,
        total_price: null,
        is_first_partial_item: true,
        partial_item_length: 1,
        selected_checkbox: false,
        disabled_checkbox: false,
        show_partial_button: true,
        merge_meta: undefined,
      }
      delete baseSaleItem.id;

      const sortedSources = sources
          .slice()
          .sort((a, b) => {
            const aMin = getMinimumTripItemId(a.trip_item_ids)
            const bMin = getMinimumTripItemId(b.trip_item_ids)
            if (aMin !== bMin) {
              return aMin - bMin
            }
            return (a.sequence ?? 0) - (b.sequence ?? 0)
          })

      const ungroupedItems = sortedSources.map(source => ({
        ...baseSaleItem,
        trip_item_ids: source.trip_item_ids || [],
        trip_items: source.trip_items || [],
        product_code: source.product_code || baseSaleItem.product_code,
      }))
      if (mergedItem.id) {
        this.$set(this.model.sale_items, selectedIndex, {
          ...mergedItem,
          _action: "delete",
        })
        saleItems.splice(selectedIndex + 1, 0, ...ungroupedItems)
      } else {
        saleItems.splice(selectedIndex, 1, ...ungroupedItems)
      }

      saleItems.sort((a, b) => {
        const aMin = getMinimumTripItemId(a.trip_item_ids)
        const bMin = getMinimumTripItemId(b.trip_item_ids)
        if (aMin !== bMin) {
          return aMin - bMin
        }
        return (a.order_key ?? 0) - (b.order_key ?? 0)
      })

      this.ensureSaleItemsOrderKeys()
    },
    recalculatePartialGroup(tripItemIds) {
      if (!Array.isArray(tripItemIds) || !tripItemIds.length) {
        return;
      }

      const saleItems = this.model.sale_items || [];
      const groupedIndexes = [];

      saleItems.forEach((item, index) => {
        if (this.lodash.isEqual(item.trip_item_ids, tripItemIds) && item._action !== "delete") {
          groupedIndexes.push(index);
        }
      });

      const groupLength = groupedIndexes.length;
      groupedIndexes.forEach((index, position) => {
        const item = saleItems[index];
        this.$set(item, "partial_item_length", groupLength);
        this.$set(item, "trip_item_relation_type", "partial");
        this.$set(item, "is_first_partial_item", position === 0);
        this.$set(item, "show_partial_button", position === groupLength - 1);
        this.$set(item, "disabled_checkbox", groupLength > 1);
        this.$set(item, "selected_checkbox", false);
      });
    },
    partialSaleItem(selectedIndex) {
      const saleItems = this.model.sale_items || [];
      const selectedItem = saleItems[selectedIndex];
      if (!selectedItem) {
        return;
      }

      const tripItemIds = selectedItem.trip_item_ids;
      if (!tripItemIds) {
        return;
      }

      let partialBase = {
        ...selectedItem,
        quality: 'fresh',
        quantity: null,
        size: null,
        unit_price: null,
        trip_item_relation_type: "partial",
        selected_checkbox: false,
        disabled_checkbox: true,
        show_partial_button: false,
      };
      delete partialBase.id;

      this.model.sale_items.splice(selectedIndex, 1, {
        ...selectedItem,
        trip_item_relation_type: "partial",
        selected_checkbox: false,
        disabled_checkbox: true,
        show_partial_button: false,
      });
      this.model.sale_items.splice(selectedIndex + 1, 0, {
        ...partialBase,
        is_first_partial_item: false,
        show_partial_button: true,
      });

      this.recalculatePartialGroup(tripItemIds);
    },
    removePartialItem(index) {
      const saleItems = this.model.sale_items || [];
      const target = saleItems[index];
      if (
          !target ||
          target.trip_item_relation_type !== "partial" ||
          target.is_first_partial_item
      ) {
        return;
      }

      const tripItemIds = target.trip_item_ids;
      if (!tripItemIds) {
        return;
      }
      if (target.id) {
        this.$set(saleItems, index, {
          ...target,
          _action: "delete",
        });
      } else {
        saleItems.splice(index, 1);
      }
      this.recalculatePartialGroup(tripItemIds);
    },
    transformTripToSaleOrder(trip) {
      let transformedSaleItems = trip.trip_items.map((tripItem, tripItemIndex) => ({
        trip_item_relation_type: 'single',
        trip_item_ids: [tripItem.id],
        trip_items: [tripItem],
        product_code: tripItem.product_code,
        quality: 'fresh',
        quantity: null,
        unit_price: null,
        total_price: null,
        is_first_partial_item: true,
        partial_item_length: 1,
        selected_checkbox: false,
        disabled_checkbox: false,
        show_partial_button: true,
        order_key: tripItemIndex,
      }))

      return {
        customer_id: trip.customer_id,
        customer: trip.customer,
        trip_id: trip.id,
        trip: trip,
        sale_items: transformedSaleItems,
      }
    },
    setDefaultAdditionalItems(orderType) {
      if (!orderType) {
        this.$set(this.model, 'sale_paid_by_jala', [])
        this.$set(this.model, 'sale_paid_by_partner', [])
        return
      }
      let paidByJala = orderType === 'harvest' ? [
        {name: "Diskon", total: 0, disabled: true, paid_by: "jala"},
        {name: "Biaya Percepatan", total: 0, disabled: true, paid_by: "jala"},
        {name: "PPH 22", total: 0, disabled: true, paid_by: "jala"}
      ] : [
        {name: "Diskon", total: 0, disabled: true, paid_by: "jala", options: { show_markup_margin_checkbox: true }},
        {name: "Biaya Percepatan", total: 0, disabled: true, paid_by: "jala"}
      ]
      let paidByPartner = orderType === 'harvest' ? [] : [
        {name: "Diskon", total: 0, disabled: true, paid_by: "partner"},
        {name: "PPH 22", total: 0, disabled: true, paid_by: "partner"},
        {name: "Moulting", total: 0, disabled: true, paid_by: "partner"}
      ]
      this.$set(this.model, 'sale_paid_by_jala', paidByJala)
      this.$set(this.model, 'sale_paid_by_partner', paidByPartner)
    },
    ticketCustomLabel(ticket = {}) {
      const {
        id,
        customer_type,
        created_at,
        creator: { name: creator_name } = {}
      } = ticket;
      const formattedDate = created_at
          ? this.$moment
              .utc(created_at)
              .local()
              .format('DD MMMM YYYY')
          : '';
      const creatorName = creator_name || '';

      return `${id}: ${this.$t(`tickets.customer_types.${customer_type}`)}, ${this.$t(
          'created_by_{name}_on_{date}',
          {
            name: creatorName,
            date: formattedDate
          }
      )}`;
    },
    ticketModifyResponse(response) {
      const data = (response && response.data && response.data.data) || [];
      if (!data.length) {
        return response;
      }

      const dataEdited = data.map(datum => {
        const trips = datum.trips || [];
        const isAllTripsAreUnloaded = trips.every(
            trip => (trip.sale_orders || []).length > 0
        );
        return {
          ...datum,
          $isDisabled:
              datum.status === 'close' ||
              ((datum.purchase_orders || []).length === 0) ||
              isAllTripsAreUnloaded
        };
      });

      const dataEnabled = dataEdited.filter(datum => !datum.$isDisabled);
      const dataDisabled = dataEdited.filter(datum => datum.$isDisabled);
      response.data.data = [...dataEnabled, ...dataDisabled];

      return response;
    },
    tripCustomLabel(trip = {}) {
      return trip?.id || '';
    },
    tripModifyResponse(response) {
      const data = (response && response.data && response.data.data) || [];
      if (!data.length) {
        return response;
      }

      const dataEdited = data.map(datum => ({
        ...datum,
        $isDisabled: (datum.sale_orders || []).length > 0
      }));

      const dataEnabled = dataEdited.filter(datum => !datum.$isDisabled);
      const dataDisabled = dataEdited.filter(datum => datum.$isDisabled);
      response.data.data = [...dataEnabled, ...dataDisabled];

      return response;
    },
    onDeleteFile(file) {
      this.$set(this.model, file, {
        name: file,
        _action: "delete"
      });
    },
    removeFile(key, fileIndex) {
      let filteredFile = this.model?.[key]
          .map((file, index) => {
            if (index == fileIndex && file.id) {
              file._action = "delete";
            }
            return file;
          })
          .filter((file, index) => {
            if (file._action === "delete") {
              return true;
            }
            return index !== fileIndex;
          });
      this.$set(this.model, key, this.lodash.cloneDeep(filteredFile));
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.validateFiles()
        })
      })
    },
    onTicketUpdated(payload) {
      if (payload) {
        this.model.ticket = payload;
      } else {
        const params = this.$route.params;
        this.$set(this.model, "ticketable", {
          ticket_id: params?.ticketable?.ticket_id
        });
        if (!this.model.trip_id) {
          this.$set(this, "model", {
            trip_id: params?.trip_id
          });
        }
      }
    },
    scrollTo(id) {
      const element = this.$el.querySelector(`#${id}`);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({behavior: "smooth", block: "center"});
        }, 100);
      }
    },
    onPurchaseOrderSelected(payload) {
      this.$set(this.model, "paymentable", {
        ...this.model.paymentable,
        ...payload
      });
      this.$set(this.model, "purchase_order_id", `${payload.map(p => p.id).toString()},`);
      this.$set(this.model, "purchase_order_selected", payload);
    },
    onPurchaseItemSelected(payload) {
      this.model.trip_items = payload;
      this.model.difference = this.differenceBiomass();
    },
    onTripSelected(payload) {
      if (!payload) {
        this.model.customer_id = null;
        this.model.trip_items = []
        this.model.sale_paid_by_jala = []
        this.model.sale_paid_by_partner = []
        return;
      }
      this.$set(this, 'model', {
        ...this.model,
        ...this.transformTripToSaleOrder(payload),
      })
    },
    checkLocalStorage() {
      let local = localStorage.getItem("purchase_order");
      if (local && !this.model.id) {
        let jsonData = JSON.parse(local);
        let vm = this;
        this.$set(this, "model", {
          ...jsonData,
          files: jsonData.files.map(function (item) {
            if (Object.keys(item).length)
              return {
                ...item,
                file: vm.dataURLtoFile(item.preview, item.name)
              };
            else return {...item};
          })
        });
      }
    },
    addItem(key, item = {}) {
      this.model[key].push(item);
    },
    addChildItem(key, index, childKey) {
      const parent = this.model[key][index];
      this.model[key][index][childKey].push({
        quality: "fresh",
        product_id: parent.product_id,
        size: null,
        quantity: null,
      });
    },
    undeletedItems(key) {
      return (this.model[key] || []).filter(r => r._action !== "delete");
    },
    undeletedChildItems(key, index, childKey) {
      return this.model[key][index][childKey].filter(r => r._action !== "delete");
    },
    removeItem(key, index) {
      const items = this.undeletedItems(key);
      if ((items[index] || {}).id) {
        items[index]._action = "delete";
      } else {
        items.splice(index, 1);
      }
      this.model[key] = items;
    },
    removeChildItem(key, index, childKey, childIndex) {
      const items = this.undeletedItems(key);
      if ((items[index][childKey][childIndex] || {}).id) {
        items[index][childKey][childIndex]._action = "delete";
      } else {
        items[index][childKey].splice(childIndex, 1);
      }
      this.model[key] = items;
    },
    dataURLtoFile(dataUrl, filename) {
      let arr = dataUrl.split(","),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {type: mime});
    },
    onBlurSaleItemQuantity(saleItem) {
      this.setSaleItemTotalPrice(saleItem);
      this.setSaleOrderTotal();
    },
    onBlurSaleItemUnitPrice(saleItem) {
      this.setSaleItemTotalPrice(saleItem);
      this.setSaleOrderTotal();
    },
    onBlurSaleAdditionalItemTotal() {
      this.setSaleOrderTotal();
    },
    setSaleItemTotalPrice(saleItem) {
      this.$set(saleItem, "total_price", (saleItem.quantity || 0) * (saleItem.unit_price || 0));
    },
    setSaleOrderTotal() {
      this.$set(this.model, "total", this.saleItemTotal + this.saleAdditionalItemTotal);
    },
    validateFiles() {
      this.$refs.fileProvider.validate()
    },
  }
};
</script>

<style scoped lang="scss">
@import "~@/design/app";

::v-deep {
  .col-form-label {
    @extend .text-sm;
    @extend .text-block;
    @extend .text-semibold;
    @extend .text-neutral-default;

    &.section-header {
      @extend .text-neutral-300;
    }

    @each $color-name, $color-value in $colors {
      &.text-#{$color-name} {
        @extend .text-#{$color-name};
      }
    }
  }
  .custom-file {
    height: 0;
    .custom-file-label {
      height: 0;
      padding: 0;
      margin: 0;
    }
  }

  legend.required-indicator::after {
    content: '*';
    color: red;
  }
}
</style>
